import script from "./ProviderFieldDiscrepancy.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderFieldDiscrepancy.vue?vue&type=script&setup=true&lang=js"

import "./ProviderFieldDiscrepancy.vue?vue&type=style&index=0&id=0f31a4d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f31a4d0"]])

export default __exports__